export const EnIcon = ({ width = '20', height = '20' }: React.SVGProps<SVGSVGElement>) => {
	return (
		<svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_33327_6212)">
				<path
					d="M24.6003 20.2892H-5.29942C-5.59428 20.2892 -5.83337 20.0501 -5.83337 19.7552V0.533949C-5.83337 0.239092 -5.59428 0 -5.29942 0H24.6004C24.8952 0 25.1343 0.239092 25.1343 0.533949V19.7552C25.1342 20.0501 24.8952 20.2892 24.6003 20.2892Z"
					fill="#41479B"
				/>
				<path
					d="M25.1342 0.533949C25.1342 0.239092 24.8952 0 24.6003 0H22.2115L12.32 6.48064V0H6.98075V6.48064L-2.91068 0H-5.29942C-5.59428 0 -5.83337 0.239092 -5.83337 0.533949V1.91485L2.65302 7.47493H-5.83337V12.8142H2.65302L-5.83337 18.3743V19.7552C-5.83337 20.0501 -5.59428 20.2892 -5.29942 20.2892H-2.91062L6.98087 13.8085V20.2892H12.3201V13.8085L22.2116 20.2892H24.6004C24.8953 20.2892 25.1344 20.0501 25.1344 19.7552V18.3743L16.648 12.8142H25.1342V7.47499H16.6479L25.1342 1.91485V0.533949Z"
					fill="#F5F5F5"
				/>
				<path
					d="M25.1342 8.54283H11.2522V0H8.04865V8.54283H-5.83337V11.7463H8.04865V20.2892H11.2522V11.7463H25.1342V8.54283Z"
					fill="#FF4B55"
				/>
				<path
					d="M4.99007 12.8145L-5.81824 19.8304C-5.78044 20.0882 -5.56784 20.2894 -5.29947 20.2894H-4.56405L6.95143 12.8145H4.99007V12.8145Z"
					fill="#FF4B55"
				/>
				<path
					d="M15.1175 12.8145H13.1561L24.6549 20.2784C24.9229 20.2498 25.1344 20.031 25.1344 19.7554V19.3164L15.1175 12.8145Z"
					fill="#FF4B55"
				/>
				<path
					d="M-5.83337 1.12207L3.95161 7.47369H5.91297L-5.52231 0.0507812C-5.70497 0.13564 -5.83337 0.317997 -5.83337 0.532653V1.12207Z"
					fill="#FF4B55"
				/>
				<path
					d="M14.2812 7.47492L25.1154 0.442074C25.0704 0.192761 24.8624 0 24.6001 0H23.8351L12.3198 7.47492H14.2812Z"
					fill="#FF4B55"
				/>
			</g>
			<defs>
				<clipPath id="clip0_33327_6212">
					<rect width="20" height="20" rx="10" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};
